import type { FC, ReactNode } from 'react';
import { useEffect } from 'react';
import { Redirect as ReactRouterRedirect } from 'react-router';
import type { RedirectProps } from 'react-router';
import { isServer } from '../../utils/utils';
import { LoadingIndicator } from '../loading-indicator/LoadingIndicator';
import { RedirectWithStatus } from './RedirectWithStatus';

interface Props extends RedirectProps {
    type: 'pwa' | 'sg';
    showLoadingIndicator?: boolean;
    loadingIndicator?: ReactNode;
    status?: number;
}

export const Redirect: FC<Props> = ({
    type = 'pwa',
    showLoadingIndicator,
    loadingIndicator: indicator,
    ...props
}) => {
    useEffect(() => {
        if (type === 'sg') {
            const url = typeof props.to === 'string' ? props.to : props.to.pathname;

            if (props.push) {
                window.location.assign(url ?? '/');
            } else {
                window.location.replace(url ?? '/');
            }
        }
        // This should only run once, since changing the url might trigger react-router useLocation to rerender while the navigation is happening
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isServer) {
        return <RedirectWithStatus {...props} status={props.status} />;
    }

    return (
        <>
            {showLoadingIndicator ? indicator || <LoadingIndicator isLoading /> : null}
            <ReactRouterRedirect {...props} />
        </>
    );
};

Redirect.defaultProps = {
    showLoadingIndicator: false,
    loadingIndicator: null,
    status: 302,
};
